<template>
  <div class="list-voucher">
    <b-table
      class="table table-responsive table-bordered mt-5"
      hover
      responsive
      :fields="fields"
      :items="items"
    >
      <template #cell(action)="data">
        <div class="d-flex justify-content-evenly">
          <button
            class="btn btn-outline-danger btn-del"
            @click="deleteItems(data.item.privilegeId)"
          >
            Delete
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import fieldsVoucher from "./fieldListVoucher.json";
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: fieldsVoucher,
    };
  },
  methods: {
    deleteItems(id) {
      this.$emit("deleteVoucher", id);
    },
  },
};
</script>

